import styles from './outline-button.module.scss';

interface OutlineButtonProps {
    children: React.ReactNode;
    className?: string;
    onClick?: () => void;
}

const OutlineButton: React.FC<OutlineButtonProps> = ({children, className, onClick, ...props}) => {
    return (
        <div className="perspective">
            <button className={`${styles.outlineButton} ${className}`} onClick={onClick} {...props}>
                {children}
            </button>
        </div>
    );
};

export {OutlineButton};
